import ApiBase from '../../ApiBase';

class Comment extends ApiBase {
    route = '/cms/elements/comments';
}

export default new Comment();
